function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#00708d",
  d: "M7.604 21.853l-.707-.707L16.043 12 6.897 2.853l.707-.707L17.457 12z"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "icon"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjQuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iY2hldnJvbl94NUZfcmlnaHQtbGF5ZXIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCgkgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjQgMjQ7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGcgaWQ9ImNoZXZyb25feDVGX3JpZ2h0Ij4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDcwOEQ7IiBwb2ludHM9IjcuNjA0LDIxLjg1MyA2Ljg5NywyMS4xNDYgMTYuMDQzLDEyIDYuODk3LDIuODUzIDcuNjA0LDIuMTQ2IDE3LjQ1NywxMiAJIi8+CgkKPC9nPgo8L3N2Zz4K";
export { SvgChevronRight as ReactComponent };